'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(InputType2) {
  InputType2["TEXT"] = "text";
  InputType2["PASSWORD"] = "password";
  InputType2["NUMBER"] = "number";
})(exports.InputType || (exports.InputType = {}));
(function(InputMode2) {
  InputMode2["NUMERIC"] = "numeric";
})(exports.InputMode || (exports.InputMode = {}));
